import { render } from "./PortfolioViking.vue?vue&type=template&id=32b4bf3f"
import script from "./PortfolioViking.vue?vue&type=script&lang=js"
export * from "./PortfolioViking.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__